import { useReveal } from "../lib/useReveal";
import AppDownloadButtons from "./AppDownloadButtons";

export default function FinalCTA() {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            id="contact"
            data-testid="final-cta-section"
            className="py-20 md:py-24 bg-background"
        >
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white px-8 py-14 md:px-14 md:py-20 text-center shadow-2xl reveal">
                    <div
                        className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_top,_#10b981_0%,_transparent_50%)]"
                        aria-hidden="true"
                    />
                    <div className="relative z-10">
                        <div id="download" className="scroll-mt-28">
                            <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight tracking-tight">
                                Hope, in your pocket
                            </h2>
                            <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
                                Between meetings, at 2 AM, or whenever the day gets loud.
                            </p>
                            <AppDownloadButtons variant="dark" showDirectory />
                        </div>
                        <p id="crisis" className="text-xs text-white/50 mt-8">
                            Genesis Recovery AI is here to support reflection, privacy, and steady
                            progress on your recovery journey.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
